import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import oldTheme from '../../Colors';

import hooks, { DISPLAY_PROGRESS_BAR } from '@g4/automation-hooks';

const increase = keyframes`
  from { left: -5%; width: 5%; }
  to { left: 130%; width: 100%; }
`;

const decrease = keyframes`
  from { left: -80%; width: 80%; }
  to { left: 110%; width: 10%; }
`;

export const BaseLine = styled.div`
  position: absolute;
  height: 5px;
  width: 150%;
  background: ${oldTheme.colors.modern.loading.background};
  opacity: 0.4;
`;

export const SubLine = styled.div`
  position: absolute;
  height: 5px;
  background: ${oldTheme.colors.modern.loading.bar};
`;

export const IncreaseLine = styled(SubLine)`
  animation: ${increase} 2s infinite;
`;

export const DecreaseLine = styled(SubLine)`
  animation: ${decrease} 2s 0.5s infinite;
`;

/** @visibleName Progress Bar */
export class ProgressBar extends PureComponent {
  static propTypes = {
    /** injects the generated stylesheet */
    className: PropTypes.string,
  };

  render() {
    return (
      <div
        className={this.props.className}
        {...hooks.hook(DISPLAY_PROGRESS_BAR)}
      >
        <BaseLine />
        <IncreaseLine />
        <DecreaseLine />
      </div>
    );
  }
}

export default styled(ProgressBar)`
  position: relative;
  height: 5px;
  width: 100%;
  overflow-x: hidden;
  box-shadow: inset 0 1px 0 0 ${oldTheme.colors.modern.loading.border},
    inset 0 -1px 0 0 ${oldTheme.colors.modern.loading.border};
`;
